<template>
  <!--
      作者 kmdshop
      时间：2020-06-09
      描述：会员-等级管理-添加商品
  -->
   <div>
  <el-dialog title="添加商品" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      
      <el-form-item :label-width="formLabelWidth" label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>


      <el-form-item :label-width="formLabelWidth" label="选择商品">
        <!-- <RelationProduct1  :form="form" ></RelationProduct1> -->
      </el-form-item>

      

      <el-form-item :label-width="formLabelWidth" label="设置返利">
        <el-table size="small" :data="gradeList" border>
          <el-table-column prop="name" label="用户等级"></el-table-column>
          <el-table-column prop="first_rebate" label="第一单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.first_rebate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="second_rebate" label="第二单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.second_rebate"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="three_rebate" label="第三单/%">
            <template slot-scope="scope">
                <el-input v-model="scope.row.three_rebate"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading">确 定</el-button>
    </div>

  
  </el-dialog>
    
    <!-- <Product :isproduct="isproduct" @closeDialog="closeDialogFunc($event)">产品列表弹出层</Product> -->
   </div>
</template>

<script>
  import Product from '@/components/product/Product';
  import LooprebateApi from '@/api/looprebate.js';

  export default {
    components: {

   
      /*产品列表组件*/
      Product:Product
    },
    data() {
      return {


        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,

        content:'',//备注
        isproduct:0,

      };
    },
    props: ['open_edit',"form", "gradeList"],
    created() {
      this.dialogVisible = this.open_edit;
      console.log("this.form",this.form)
      this.gradeList = this.form.gradeLists
    },
    methods: {

      /*添加等级*/
      addGrade() {
        let self = this;
        let params = this.form;
        params.gradeList =JSON.stringify(this.gradeList);
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            LooprebateApi.updLooprebate(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

       /*产品列表弹出层*/
      openProduct() {
        this.isproduct = true;
      },
      /*关闭弹窗*/
      closeDialogFunc(e) {
        this.isproduct = e.openDialog;
        console.log("success",e);
        if (e.type == 'success') {
          if (this.form.upgrade_goods_id.indexOf(e.params.product_sku_id) == -1) {
            this.form.upgrade_goods_id.push(e.params.product_sku_id);
            this.form.product = { 
              product_sku_id:e.params.product_sku_id,
               product_id: e.params.product_id,
                product_image: e.params.product_image,
                product_name: e.params.product_name 
            };
          } else {
            this.$message({
              message: '已选择该商品',
              type: 'warning'
            });
          }
        
          
        }
      },
      /*删除商品*/
      deleteFunc(i) {
        this.form.upgrade_goods_id.splice(i, 1);
        this.form.product.splice(i, 1);
      },
    }
  };
</script>

<style scoped="scoped">
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}

.img img {
  border: 1px solid #eeeeee;
}

.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/team/index/edit.vue